import createTheme from './createTheme'

export default createTheme({
  colors: {
    main: '#3C3D3E',
    main90: '#434345',
    main80: '#555759',
    main70: '#a3a2a2',
    main60: '#9B9B9B',
    main50: '#e2dede',
    main40: '#DEDEDE',
    main30: '#f5f2f2',
    main20: '#EBEBEB',
    main10: '#f2efef',

    darkMain: '#000',
    darkMain90: '#111',
    darkMain80: '#3C3D3E',
    darkMain70: '#444',
    darkMain60: '#555759',
    darkMain50: '#666',
    darkMain40: '#9B9B9B',
    darkMain30: '#AAA',
    darkMain20: '#DEDEDE',
    darkMain10: '#EEE',

    accent: '#F2FAF6',
    accent90: '#F2FAF6',
    accent80: '#F4FBF8',
    accent70: '#F4FBF8',
    accent60: '#F6FCF9',
    accent50: '#F6FCF9',
    accent40: '#F9FDFB',
    accent30: '#F9FDFB',
    accent20: '#FBFDFC',
    accent10: '#FBFDFC',
    accent_dark: '#b2d7c5',

    leftMenuOpeBg: '#3C3D3E',

    focusColor: '#005eca',
  },
  components: {
    button: {
      backgroundColor: 'main',
    },
  },
})
